import { Link } from "react-router-dom";
import logo from "../images/logo.png"
import code from "../images/code.jpg";

const Navbar = () => {
  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark shadow-sm"
      style={{ backgroundColor: "#1D223D" }}
    >
      <div className="container">
        <Link className="navbar-brand fw-bold d-flex align-items-center" to="/">
          <img
            src={logo}
            alt="Site Logo"
            style={{
              height: "40px",
              width: "40px",
              marginRight: "12px",
              borderRadius: "50%",
              boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
              background: "#fff",
              objectFit: "cover"
            }}
          />
          SEngineering
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link text-uppercase" to="/about">
                About
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-uppercase" to="/products">
                Products
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-uppercase" to="/services">
                Services
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link text-uppercase"
                to="/contact"
                target="_blank"
                rel="noopener noreferrer"
              >
                Contact
              </Link>
            </li>
            <li className="nav-item ms-3">
              <Link
                className="nav-link text-uppercase btn px-4 mx-2"
                to="/studio"
                style={{
                  borderRadius: "20px",
                  background: "linear-gradient(90deg, #264d00 0%, #4caf50 40%, #b6ff4a 80%, #264d00 100%)",
                  color: "#fff",
                  fontWeight: "bold",
                  boxShadow: "0 2px 18px rgba(38,77,0,0.25), 0 2px 12px rgba(76,175,80,0.10)",
                  border: "2px solid #264d00",
                  letterSpacing: "1.5px",
                  transition: "transform 0.15s, box-shadow 0.15s",
                  transform: "scale(1.08)"
                }}
              >
                <span style={{
                  fontSize: "1.1rem",
                  textShadow: "0 1px 2px #1D223D, 0 0px 0px #b6ff4a",
                  filter: "none"
                }}>
                  Studio
                </span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
